import React from "react";
import { Dialog, DialogContent, Button, Stack, Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';

function RmvProdCatalogPopup({ open, handleClose, handleRmvClick }) {
    return (
        <Dialog open={open}
            onClose={handleClose}
            aria-labelledby="Logout-PopUp"
            sx={{ "& .MuiPaper-root": { borderRadius: "16px" }, }} width="100%" height="100%">
            <DialogContent sx={{ width: 400, height: 210 }} >
                <Stack width={"100%"} direction={"column"} alignItems={"center"}>
                    <ErrorIcon sx={{ color: "red", fontSize: 30 }} />
                    <Typography sx={{ fontSize: 14, fontWeight: 500, marginTop: 3, marginBottom: 3, fontFamily: "Poppins" }} >
                        Once a product is removed from the catalogue, this action cannot be undone!
                    </Typography>

                    <Stack direction={"row"} sx={{ mt: 2 }}>
                        <Button
                            variant="outlined" onClick={handleRmvClick}
                            sx={{
                                borderRadius: 2, px: 2, py: 0.5, fontSize: 14, mr: 2, textTransform: "uppercase", color: "rgba(0, 0, 139, 0.7)",
                                backgroundColor: "#e0e0e0",
                                "&:hover": { backgroundColor: "#e0e0e0", },
                            }}>
                            Remove
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={handleClose}
                            sx={{
                                borderRadius: 2, bgcolor: "rgba(255, 183, 3, 1)", color: "rgba(7, 42, 200, 1)", px: 2, py: 0.5,
                                fontSize: 14, textTransform: 'uppercase'
                            }} >
                            Cancel
                        </Button>
                    </Stack></Stack>
            </DialogContent>
        </Dialog>
    );
};
export default RmvProdCatalogPopup;
